export const defaultGtm = () => ({
    showDeal: {
        event: 'fac_button_click',
        category: 'vuejs-funil-vendas',
        action: 'click',
        label: 'Visualizar Negócio'
    },
    showProduct: {
        event: 'fac_button_click',
        category: 'vuejs-funil-vendas',
        action: 'click',
        label: 'Visualizar Empreendimento'
    },
})